import { Navigate, useNavigate } from 'react-router-dom';

import DashboardIcon from '@mui/icons-material/Dashboard';
import { Stack, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HomeIcon from '@mui/icons-material/Home';
import { useAuthenticator } from '@aws-amplify/ui-react';

const ReportSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  const handleClick = () => {
    if (authStatus != 'authenticated'){
      navigate('/public')
    }
    else{
      navigate('/app')
    }
  }
  return (
    <Box sx={{ ml: theme.spacing(2) }}>
      <Button
        color="inherit"
        onClick={handleClick}
        sx={{ display: { xs: 'none', sm: 'block' }, color: 'primary.main', textTransform: 'none' }}
      >
           <Stack direction="row" alignItems="center" spacing={1}>
          <HomeIcon sx={{ color: 'primary.main' }} />
          <Typography variant = 'h3' sx={{ color: 'primary.main' }}><b>Home</b></Typography>
        </Stack>
      </Button>
    </Box>
  );
};

export default ReportSection;
